import { render, staticRenderFns } from "./CustomerOwnedAwsAccounts.vue?vue&type=template&id=630d90a3&scoped=true&"
import script from "./CustomerOwnedAwsAccounts.vue?vue&type=script&lang=js&"
export * from "./CustomerOwnedAwsAccounts.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOwnedAwsAccounts.vue?vue&type=style&index=0&id=630d90a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d90a3",
  null
  
)

export default component.exports